import React, { Fragment } from "react";
import { Box, Container, Typography, Divider, Paper } from "@mui/material";
import SEO from "../../components/ceo/CEO";

const Privacy = () => {
  return (
    <Fragment>
      <SEO
        title="Privacy Policy"
        description="Learn about the privacy policies of SHALL Social and Development Organization, how we collect and use data, and your rights regarding your personal information."
        url="https://shallafg.org/privacy/"
        image="https://shallafg.org/media/images/logo.png"
      />
      <Box
        sx={{
          backgroundColor: "#0B0F19",
          color: "#FFFFFF",
          paddingY: { xs: "40px", md: "80px" },
          minHeight: "100vh",
        }}
      >
        <Container maxWidth="md">
          <Paper
            sx={{
              padding: { xs: "20px", md: "50px" },
              backgroundColor: "#1A2E55",
              borderRadius: "16px",
              boxShadow: "0 8px 40px rgba(0, 0, 0, 0.5)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
            }}
          >
            {/* Privacy Policy Header */}
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: "#E3F2FD",
                textAlign: "center",
                marginBottom: "40px",
                fontSize: { xs: "2rem", md: "3rem" },
                letterSpacing: "1px",
              }}
            >
              Privacy Policy
            </Typography>

            {/* Section */}
            {privacySections.map((section, index) => (
              <Box key={index} sx={{ marginBottom: "40px" }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: "#A9C9EA",
                    fontSize: { xs: "1.4rem", md: "1.6rem" },
                    marginBottom: "10px",
                    letterSpacing: "0.5px",
                  }}
                >
                  {section.title}
                </Typography>
                <Divider
                  sx={{
                    backgroundColor: "#007BFF",
                    marginBottom: "20px",
                    height: "2px",
                    width: "100px",
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.2rem" },
                    lineHeight: "1.8",
                    color: "#D1D5DB",
                  }}
                >
                  {section.content}
                </Typography>
              </Box>
            ))}

            {/* Footer Note */}
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                color: "#90CAF9",
                marginTop: "40px",
                fontStyle: "italic",
              }}
            >
              This policy is effective as of 2024. By using our website, you
              agree to this policy.
            </Typography>
          </Paper>
        </Container>
      </Box>
    </Fragment>
  );
};

const privacySections = [
  {
    title: "1. Information We Collect",
    content:
      "We collect personal information like your name, email, and payment details when you visit our website, sign up, donate, or join our activities. We also collect non-personal data like your browser type and IP address.",
  },
  {
    title: "2. How We Use Your Information",
    content:
      "We use your data to manage our services, process donations, send updates, communicate with you, and keep our website secure.",
  },
  {
    title: "3. Data Security",
    content:
      "We protect your personal information from unauthorized access, alteration, or misuse with appropriate security measures.",
  },
  {
    title: "4. Sharing Your Information",
    content:
      "We don’t sell or share your information, except with trusted partners or if required by law.",
  },
  {
    title: "5. Cookies",
    content:
      "We use cookies to improve your experience on our website. You can control cookies in your browser settings.",
  },
  {
    title: "6. Your Rights",
    content:
      "You can access, correct, or delete your personal data and opt out of communications at any time.",
  },
  {
    title: "7. Third-Party Links",
    content:
      "We are not responsible for the privacy or security of other websites linked to ours.",
  },
  {
    title: "8. Policy Updates",
    content:
      "We may change this policy, so please review it regularly. Using our services means you accept the updated policy.",
  },
  {
    title: "9. Contact Us",
    content: "If you have questions, contact us by email or phone.",
  },
];

export default Privacy;
